import axios from 'axios';
import { getEnvironment } from '@global/helpers';
const Config = getEnvironment();

const baseUrl = Config.MS_B2B_API_URL;

const getDashboardData = (target = '', type = 'national', params = {}) => {
  return axios.get(`${baseUrl}/dashboards/${target}-${type}`, params);
};

export const Dashboard = {
  getDashboardData,
};
